import { useMutation } from "@tanstack/react-query"
import { wrappedAxios } from "../../../api/auth"
import { _extendWithAuthPersistence } from "../../../hooks/react-query/utils"

const birddogSignupURL =
  import.meta.env.VITE_APP_BARK_API_ROOT_URL + "birddog/signup/"

const birddogSignup = async (values: {
  email: string
  password: string
  first_name: string
  last_name: string
  company_name: string
  role: "forester" | "timber_buyer"
}): Promise<any> => {
  const res = await wrappedAxios("post", birddogSignupURL, values, {
    withCredentials: true,
  })
  return res.data
}

export function useBirddogSignup(config = {}) {
  config = _extendWithAuthPersistence(config)
  return useMutation({ mutationFn: birddogSignup, ...config })
}
